<template>
  <el-container style="width: 100%">
    <el-header>
      <el-button round @click="createClick">{{generateCustomizeString('add')}}</el-button>
      <el-button round @click="freshClick">{{generateCustomizeString('refresh')}}</el-button>
    </el-header>
    <el-main style="height:100%; margin-bottom:60px;">
      <el-table
        :data="brandsData"
        tooltip-effect="dark"
        style="width: 100%; margin-bottom:60px;"
        v-loading.body="brandListLoading"
      >
        <el-table-column prop="brandName" :label="generateCustomizeString('brandName')"></el-table-column>
        <el-table-column :label="generateCustomizeString('brandLogo')" width="240">
          <template slot-scope="scope">
            <img :src="scope.row.logoUrl" style="width:auto;height:100px;" />
          </template>
        </el-table-column>
        <el-table-column prop="brandInitials" :label="generateCustomizeString('brandInitials')"></el-table-column>
        <el-table-column prop="sortWeight" :label="generateCustomizeString('sortWeight')"></el-table-column>
        <el-table-column prop="brandCreateAt" :label="generateCustomizeString('createAt')">
          <template slot-scope="scope">{{scope.row.brandCreateAt | toLocalTime}}</template>
        </el-table-column>
        <el-table-column prop="brandActivity" :label="generateCustomizeString('brandActivity')">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.brandActivity === 1"
              type="success"
              close-transition
            >{{generateCustomizeString('brandReady')}}</el-tag>
            <el-tag
              v-else
              type="info"
              close-transition
            >{{generateCustomizeString('brandWaitForReview')}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="generateCustomizeString('operate')" width="180">
          <template slot-scope="scope">
            <el-button
              @click="editClick(scope.row)"
              type="text"
              size="small"
            >{{generateCustomizeString('edit')}}</el-button>
            <el-button
              type="text"
              size="small"
              @click="deleteClick(scope.row.brandId)"
            >{{generateCustomizeString('delete')}}</el-button>
            <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
              <span>确定删除该品牌？</span>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="deleteBrand()">确 定</el-button>
              </span>
            </el-dialog>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="15"
        layout="total, prev, pager, next"
        :total="currentTotal"
      ></el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'Brand',
  data() {
    return {
      brandsData: [],
      brandListLoading: false,
      dialogVisible: false,
      selectDeleteId: 0,
      currentPage: 1,
      currentTotal: 0
    }
  },
  methods: {
    generateCustomizeString,
    editClick(row) {
      this.$router.push({ name: 'EditBrand', params: { brandId: row.brandId }})
    },
    viewClick(row) {
      this.$router.push({ name: 'ViewBrand', params: { brandId: row.brandId }})
    },
    createClick() {
      this.$router.push({ name: 'CreateBrand' })
    },
    deleteClick(brandId) {
      this.dialogVisible = true
      this.selectDeleteId = brandId
    },
    freshClick() {
      this.fetchData(this.currentPage)
    },
    handleCurrentChange(val) {
      this.fetchData(val)
    },
    fetchData(page) {
      if (this.brandListLoading) return
      this.brandListLoading = true

      request({
        url: 'brands',
        method: 'get',
        params: {
          page: page
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.brandId = response.data[i].id
            obj.brandName = response.data[i].brand_name
            obj.logoUrl =
              response.data[i].branch_pic_url +
              '?imageView2/0/w/200/h/200/q/75|imageslim'
            obj.brandInitials = response.data[i].alias
            obj.sortWeight = response.data[i].sort_by
            obj.brandActivity = response.data[i].is_show
            obj.brandCreateAt = response.data[i].created_at
            data[i] = obj
          }

          this.brandsData = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.brandListLoading = false
        })
    },
    deleteBrand() {
      if (this.selectDeleteId === 0) return
      request({
        url: 'brand/' + this.selectDeleteId,
        method: 'delete'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('deletedSuccessfully'),
              type: 'success'
            })
          } else {
            if (res.status === 60015) {
              this.$message.error(
                this.generateCustomizeString('brandDeletedError')
              )
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('deleteFailed'))
        })
        .finally(() => {
          this.fetchData(this.currentPage)
          this.dialogVisible = false
          this.selectDeleteId = 0
        })
    }
  },
  created: function() {
    this.fetchData(1)
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    }
  },
  watch: {
    viewActived: function(newValue) {
      this.freshClick()
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.meta && to.meta.badge) {
      to.meta.badge = null
    }
    next()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #efefef;
  // color: #333;
  text-align: left;
  line-height: 60px;
}
</style>
